import { Link, useParams } from "react-router-dom";

const ServiceMenuAccordian = ({ id, title, slug, service_items, parentId }) => {
	const param = useParams();

	return (
		<div className="accordion-item my-3">
			<h2 className="accordion-header" id={`heading-${id}`}>
				<button
					className={`accordion-button ${
						slug === param.category ? "" : "collapsed"
					}`}
					type="button"
					data-bs-toggle="collapse"
					data-bs-target={`#collapse-${id}`}
					aria-expanded="false"
					aria-controls={`collapse-${id}`}
				>
					{title}
				</button>
			</h2>

			<div
				id={`collapse-${id}`}
				className={`accordion-collapse collapse accordian-container ${slug === param.category ? "show" : ""
				} `}
				aria-labelledby={`heading-${id}`}
				data-bs-parent={`#${parentId}`} // This links the accordions together (only one open at a time)
			>
				{service_items?.map((item, index) => (
					<Link
						key={index}
						to={`/services/${slug}/${item?.slug}`}
						className={`accordion-body accordian-item ${
							item?.slug === param.item ? "active" : ""
						}`}
					>
						{item?.title}
					</Link>
				))}
			</div>
		</div>
	);
};

export default ServiceMenuAccordian;
